import { z } from 'zod';
import { SlideVideoOptionsSchema } from './SlideVideoOptions';
import { TriggerId, TriggerIdSchema } from './TriggerId';

export type StructureData = {
  id: string;
  slideGroupId: string;
  slideIds: string[];
  sensorIds: string[];
  triggerIds: TriggerId[];
  initialState: string | null;
  children: StructureData[];
};

// Then create the schema
export const StructureDataSchema: z.ZodType<StructureData> = z.object({
  id: z.string(),
  slideGroupId: z.string(),
  slideIds: z.array(z.string()),
  sensorIds: z.array(z.string()),
  triggerIds: z.array(TriggerIdSchema),
  initialState: z.string().nullable(),
  children: z.lazy(() => z.array(StructureDataSchema)),
});

export const PlayerSlideBaseSchema = z.object({
  id: z.string().optional(),
  index: z.number(),
  name: z.string(),
  contentType: z.string(),
  slideGroupId: z.string().optional(),
  structureData: StructureDataSchema.optional(),
  videoOptions: SlideVideoOptionsSchema.nullable().optional(),
});

export const EditorSlideBaseSchema = PlayerSlideBaseSchema.extend({
  slideId: z.string(),
  asset: z.string().optional(),
});
